"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseHook = exports.getHookedMethods = exports.hasHookedMethods = exports.Hook = void 0;
const SYM_HOOKED_METHODS = Symbol("SYM_HOOKED_METHODS");
/**
 * Execute the underlying method when the given hook is triggered.
 * @param cls - The hook class definition
 */
const Hook = (cls) => {
    return (target, propertyKey) => {
        var _a;
        const hookedMethods = (target[SYM_HOOKED_METHODS] = (_a = target[SYM_HOOKED_METHODS]) !== null && _a !== void 0 ? _a : new Map());
        hookedMethods.set(propertyKey, cls);
    };
};
exports.Hook = Hook;
function hasHookedMethods(obj) {
    return SYM_HOOKED_METHODS in obj;
}
exports.hasHookedMethods = hasHookedMethods;
function getHookedMethods(obj) {
    return obj[SYM_HOOKED_METHODS];
}
exports.getHookedMethods = getHookedMethods;
/**
 * Base class of a hook definition. You must extend it to create your own hook definition.
 */
class BaseHook {
    constructor(
    /**
     * The hook sender
     */
    sender) {
        this.sender = sender;
    }
}
exports.BaseHook = BaseHook;
//# sourceMappingURL=hook.js.map